export default __webpack_public_path__ + "111a5c446c8c786359fd3a1e9f8cbbe3.svg";